import { Flex } from 'antd'
import { createStyles } from 'antd-style'

import { UserAvator } from '@eastcoal/shared/components/UserAvatar'

import { AuditLink } from './AuditLink'
import { EnterpriseInfo } from './EnterpriseInfo'
import { Manager } from './Manager'
import { Phone } from './Phone'
import { UserInfo } from './UserInfo'
import { Wechat } from './Wechat'

const useStyles = createStyles(({ token }) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gridTemplateRows: '36px 36px auto',
    gridTemplateAreas: `
      "a c"
      "a d"
      "b e"
      `,
    columnGap: token.paddingSM,
    alignItems: 'stretch'
  },
  avatar: {
    gridArea: 'a'
  },
  auditLink: {
    gridArea: 'b',
    lineHeight: '24px'
  },
  userInfo: {
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }
}))

export const MemberInfo = () => {
  const { styles } = useStyles()

  return (
    <div className={styles.container}>
      <UserAvator className={styles.avatar} disabled={false} size={72} />
      <AuditLink className={styles.auditLink} />
      <EnterpriseInfo />
      <div className={styles.userInfo}>
        <UserInfo />
      </div>
      <Flex align='center' gap={24}>
        <Wechat />
        <Phone />
        <Manager />
      </Flex>
    </div>
  )
}
